const calculateStopProblems = (stop, index, { stopScore, currentStopIndex, pendingStopIndex }) => {
  const isCurrent = currentStopIndex === index;

  const isStandStill = isCurrent && stop.standstill;
  const isLate = stop.is_late;
  const isNotStarted = stop.is_not_started;
  const isPossibleDelay = !!stop.delayed_datetime;

  return {
    STOP_STANDSTILL: isStandStill,
    STOP_NOT_STARTED: isNotStarted,
    STOP_POSSIBLE_DELAY: isPossibleDelay,
    STOP_LATE: isLate,
  };
};

export { calculateStopProblems };
